import { Calendar } from "lucide-react";
import { Input } from "@/components/ui/Input";

/** Thin wrapper around a native date input, styled to match the design system. */
export function DatePicker({
  value,
  onChange,
  className,
  min,
  max,
}: {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  min?: string;
  max?: string;
}) {
  return (
    <div className={className ? className : "relative w-40"}>
      <Calendar className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-faint" />
      <Input
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        min={min}
        max={max}
        className="pl-9"
      />
    </div>
  );
}
